module.exports = __webpack_public_path__ + "img/flange_drill_holes.95ef0b90.webp";